export const DEFAULT_PAGE_SIZE = 30;

export const initialPagination = {
  current: 1,
  has_next_page: false,
  limit: DEFAULT_PAGE_SIZE,
  next: null,
  previous: null,
  total_count: 0,
  total_pages: 0,
};

export async function fetchAllPages({
  fetchPage,
  getItems,
  getPagination = (data) => data.pagination,
  per = DEFAULT_PAGE_SIZE,
  signal,
  maxPages = 100,
}) {
  let page = 1;
  let allItems = [];
  let hasNextPage = true;

  while (hasNextPage && page <= maxPages) {
    if (signal?.aborted) {
      break;
    }

    const response = await fetchPage({ page, per });
    const data = response.data;
    allItems = allItems.concat(getItems(data) || []);
    const pagination = getPagination(data);
    hasNextPage = pagination?.has_next_page ?? false;
    page += 1;
  }

  return allItems;
}

export async function fetchAllPagesFromListApi(api, { itemsKey, params = {} }) {
  return fetchAllPages({
    fetchPage: ({ page, per }) =>
      api.list({
        params: {
          ...params,
          page,
          per,
        },
      }),
    getItems: (data) => data[itemsKey],
  });
}

export function getPaginatedParams(page = 1, per = DEFAULT_PAGE_SIZE, extra = {}) {
  return {
    page,
    per,
    ...extra,
  };
}
